module.exports = __webpack_public_path__ + "static/media/loan_report.fa713fbb.svg";